import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { Typography } from '@/components/Typography';
import type { Maybe } from '@/lib/types';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';

export const Wrapper = styled(Flex)<{ imagePosition: Maybe<string> }>`
  ${({ backgroundColor, imagePosition, theme }) => css`
    flex-direction: ${imagePosition === 'right' ? 'column-reverse' : 'column'};
    background-color: ${backgroundColor || theme.colors.primary};
    margin-top: ${({ theme }) => theme.spacing(2)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};

    ${theme.media.md.up} {
      flex-direction: ${imagePosition === 'right' ? 'row-reverse' : 'row'};
    }
  `}
`;

export const Image = styled(NextImageWithLoader)`
  position: relative;
  overflow: hidden;
  min-height: 250px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      min-height: 350px;
      width: 50%;
      height: initial;
    }
  `};
  .next-image {
    object-fit: cover;

    ${({ theme }) => theme.media.md.down} {
      margin-bottom: -2px;
    }
  }
`;

export const Content = styled(Box)<{ textAlignment: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${({ textAlignment, theme }) => css`
    text-align: ${textAlignment};
    padding: ${theme.spacing(2)};

    ${theme.media.md.up} {
      width: 50%;
      padding: ${theme.spacing(5)} 8.5%;
    }
  `}
`;

export const Title = styled(Typography)`
  text-transform: uppercase;
  text-align: center;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h3};
    margin-bottom: ${theme.spacing(1)};
    line-height: ${theme.lineHeights.h3};

    ${theme.media.md.up} {
      max-width: 400px;
      text-align: left;
      font-size: ${theme.fontSizes.h2};
      line-height: ${theme.lineHeights.h1Mobile};
      margin-bottom: ${theme.spacing(2)};
    }
  `}
`;

export const Text = styled(Box)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.lineHeights.h5Mobile};
  `}
`;

export const CTA = styled(LegacyButton)`
  ${({ theme, variant }) => css`
    margin-top: ${theme.spacing(2)};
    text-transform: none;

    ${variant === 'link' &&
    css`
      svg {
        transition: ${theme.transitions.create('fill')};
      }

      &:hover {
        color: ${theme.colors.white};

        svg {
          fill: ${theme.colors.white};
        }
      }
    `}
  `}
`;

export const Chevron = styled(ChevronSvg)`
  width: 24px;
  fill: ${({ theme }) => theme.colors.black};
`;
